export default function getCookie(name) {
  if (typeof document !== 'undefined') {
    const matchData = document.cookie.match(`(?:^|;)\\s*${name}=([^;]*)`)
    return matchData?.[1] ?? null
  }
}
